import Tour from './Tour.vue'

export { Tour }
export default Tour
